import { AmountOffCouponBase } from '../amount-off/amount-off-base';
import { FirstMatchGroupItemTriggerItemsQualifier } from "../../coupon-qualifiers/trigger-items/first-match-group-item-trigger-items";
export class PercentAmountOffCoupon extends AmountOffCouponBase {
    constructor(appType, sourceData, deps, baseData, identity) {
        super(appType, sourceData, deps, baseData, identity);
        this._preQualifiers.push(new FirstMatchGroupItemTriggerItemsQualifier(this._data));
    }
    getDiscountItems(cart) {
        return this._getDiscountItemsFromTriggers(cart);
    }
    computeDiscountAmount(totalAmounts, cart) {
        let amt = (totalAmounts.orderItemPrice * this._discountAmount / 100) - totalAmounts.couponAddOnPrice;
        amt = Math.max(0, this._adjustDiscountAmount(cart, amt));
        return amt;
    }
}
//# sourceMappingURL=percent-amount-off.js.map